var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M17,37.3c0,0.1,0.1,0.1,0.2,0.1h20c0.2,0,0.4-0.1,0.5-0.3l1.4-1.5c0.2-0.2,0.2-0.6,0-0.8L38,33.5l1.1-1.2 c0.2-0.2,0.2-0.6,0-0.8l-1.2-1.3l1.2-1.2c0.2-0.2,0.2-0.6,0-0.8L38,27l1.1-1.3c0.2-0.2,0.2-0.6,0-0.8L38,23.7l1.1-1.3 c0.2-0.2,0.2-0.5,0-0.7L37.6,20c-0.1-0.1-0.2-0.2-0.4-0.2h-6.4v-5.6l0,0c0-3.7-5.5-6.6-12.4-6.6S5.9,10.5,5.9,14.2v16.6l0,0 C5.9,34.2,10.7,37,17,37.3z M25.3,19.8c1.7-0.5,3.2-1.5,4.4-2.8v2.8H25.3z M18.4,8.7c6.1,0,11.3,2.5,11.3,5.5s-5.2,5.6-11.3,5.6 S7,17.2,7,14.2S12.2,8.7,18.4,8.7z M7,30.8L7,30.8V17c1.9,2.3,6.2,3.8,11.2,3.9v1.5c0,0.3,0.3,0.6,0.6,0.6l0,0 c0.3,0,0.5-0.3,0.5-0.6v-1.5h17.6l1,1.1l-1.1,1.3c-0.2,0.2-0.2,0.5,0,0.7l1.1,1.3l-1.1,1.3c-0.2,0.2-0.2,0.5,0,0.7l1.1,1.3l-1.1,1.3 c-0.2,0.2-0.2,0.5,0,0.7l1.1,1.3l-1.1,1.3c-0.2,0.2-0.2,0.5,0,0.7l1.1,1.3L37,36.3H18.9c0.3,0,0.5-0.3,0.4-0.6c0,0,0,0,0,0v-1.8 c0-0.3-0.2-0.6-0.5-0.6c-0.3,0-0.6,0.3-0.6,0.6l0,0v1.8c0,0.3,0.2,0.5,0.4,0.6h-0.2C12.1,36.3,6.9,33.7,7,30.8z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M7,14.2c0,3,5.2,5.6,11.4,5.6s11.3-2.6,11.3-5.6s-5.2-5.5-11.3-5.5S7,11.2,7,14.2z M18.4,16.4 c-2.2,0-3.9-0.9-3.9-2.2s1.7-2.2,3.9-2.2s3.8,1,3.8,2.2S20.5,16.4,18.4,16.4z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M29.6,19.8V17c-1.2,1.3-2.7,2.3-4.4,2.8H29.6z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "M18.4,36.3h0.2c-0.2-0.1-0.4-0.3-0.4-0.6v-1.8c0-0.3,0.3-0.6,0.6-0.6l0,0c0.3,0,0.5,0.3,0.5,0.6v1.8 c0.1,0.3-0.1,0.5-0.4,0.6c0,0,0,0,0,0H37l0.9-1.1l-1.1-1.3c-0.2-0.2-0.2-0.5,0-0.7l1.1-1.3l-1.1-1.3c-0.2-0.2-0.2-0.5,0-0.7l1.1-1.3 l-1.1-1.3c-0.2-0.2-0.2-0.5,0-0.7l1.1-1.3L36.8,24c-0.2-0.2-0.2-0.5,0-0.7l1.1-1.3l-1-1.1H19.2v1.5c0,0.3-0.2,0.6-0.5,0.6 c-0.3,0-0.6-0.3-0.6-0.6v0v-1.5c-5-0.1-9.3-1.6-11.2-3.9v13.8l0,0C7,33.7,12.2,36.3,18.4,36.3z M18.8,24.4c0.3,0,0.5,0.3,0.5,0.6 v1.9c0,0.3-0.2,0.5-0.5,0.5c-0.3,0-0.6-0.2-0.6-0.5V25C18.1,24.7,18.4,24.4,18.8,24.4C18.8,24.4,18.8,24.4,18.8,24.4z M18.1,29.4 c0-0.3,0.3-0.5,0.6-0.5c0.3,0,0.5,0.2,0.5,0.5v1.9c0,0.3-0.2,0.6-0.5,0.6c-0.3,0-0.6-0.3-0.6-0.6l0,0V29.4z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M18.2,26.9c0,0.3,0.3,0.5,0.6,0.5c0.3,0,0.5-0.2,0.5-0.5V25c0-0.3-0.2-0.6-0.5-0.6c-0.3,0-0.6,0.3-0.6,0.6 l0,0V26.9z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M18.8,31.9c0.3,0,0.5-0.3,0.5-0.6v-1.9c0-0.3-0.2-0.5-0.5-0.5c-0.3,0-0.6,0.2-0.6,0.5v1.9 C18.1,31.6,18.4,31.9,18.8,31.9L18.8,31.9z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M18.4,12c-2.2,0-3.9,1-3.9,2.2s1.7,2.2,3.9,2.2s3.8-0.9,3.8-2.2S20.5,12,18.4,12z M18.4,15.3 c-1.7,0-2.7-0.6-2.7-1.1s1-1.1,2.7-1.1s2.7,0.7,2.7,1.1C21,14.6,20,15.3,18.4,15.3z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  fill: "#C9C9C9",
  d: "M18.4,13.1c-1.7,0-2.7,0.7-2.7,1.1c0,0.4,1,1.1,2.7,1.1s2.7-0.6,2.7-1.1S20,13.1,18.4,13.1z"
});

function SvgHousekeepingSupplies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHousekeepingSupplies);
export default __webpack_public_path__ + "static/media/housekeeping_supplies.fc91e56b640365351b495c1a7ebabebf.svg";
export { ForwardRef as ReactComponent };